const { _CUSTOM_CONFIG } = window;

// api
export const META = _CUSTOM_CONFIG.payroll;
